import createLucideIcon from '../createLucideIcon';

/**
 * @component @name UserCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTVINmE0IDQgMCAwIDAtNCA0djIiIC8+CiAgPHBhdGggZD0ibTE0LjMwNSAxNi41My45MjMtLjM4MiIgLz4KICA8cGF0aCBkPSJtMTUuMjI4IDEzLjg1Mi0uOTIzLS4zODMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAxMi4yMjgtLjM4My0uOTIzIiAvPgogIDxwYXRoIGQ9Im0xNi44NTIgMTcuNzcyLS4zODMuOTI0IiAvPgogIDxwYXRoIGQ9Im0xOS4xNDggMTIuMjI4LjM4My0uOTIzIiAvPgogIDxwYXRoIGQ9Im0xOS41MyAxOC42OTYtLjM4Mi0uOTI0IiAvPgogIDxwYXRoIGQ9Im0yMC43NzIgMTMuODUyLjkyNC0uMzgzIiAvPgogIDxwYXRoIGQ9Im0yMC43NzIgMTYuMTQ4LjkyNC4zODMiIC8+CiAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxNSIgcj0iMyIgLz4KICA8Y2lyY2xlIGN4PSI5IiBjeT0iNyIgcj0iNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-cog
 * @see https://lucide.dev/guide/packages/lucide-vue - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {Component} Vue Component
 *
 */
const UserCog = createLucideIcon('UserCogIcon', [
  ['path', { d: 'M10 15H6a4 4 0 0 0-4 4v2', key: '1nfge6' }],
  ['path', { d: 'm14.305 16.53.923-.382', key: '1itpsq' }],
  ['path', { d: 'm15.228 13.852-.923-.383', key: 'eplpkm' }],
  ['path', { d: 'm16.852 12.228-.383-.923', key: '13v3q0' }],
  ['path', { d: 'm16.852 17.772-.383.924', key: '1i8mnm' }],
  ['path', { d: 'm19.148 12.228.383-.923', key: '1q8j1v' }],
  ['path', { d: 'm19.53 18.696-.382-.924', key: 'vk1qj3' }],
  ['path', { d: 'm20.772 13.852.924-.383', key: 'n880s0' }],
  ['path', { d: 'm20.772 16.148.924.383', key: '1g6xey' }],
  ['circle', { cx: '18', cy: '15', r: '3', key: 'gjjjvw' }],
  ['circle', { cx: '9', cy: '7', r: '4', key: 'nufk8' }],
]);

export default UserCog;
